import React, {Component} from 'react';
import * as R from 'ramda';
import classNames from 'classnames';
import t from 'tcomb-form';
import FormMultiRadio from './form_multi_radio';
import FormTagInput from './form_tag_input';
import FormToggleComponent from './form_toggle_component';

export default class FormTagInputWithRadioDefaults extends Component {
    static displayName = 'FormTagInputWithRadioDefaults';

    constructor(props) {
        super(props);
        const {value} = props;
        this.state = {
            value: value ? value.split(',') : [],
            defaultMap: R.reduce(
                (acc, defaultValue) => {
                    acc[defaultValue.toLowerCase()] = true;
                    return acc;
                },
                {},
                props.options.defaultValues
            )
        };
    }

    getDefaultValues() {
        return R.pipe(
            R.filter(val => !!this.state.defaultMap[val.toLowerCase()]),
            R.map(val => val.toLowerCase())
        )(this.state.value);
    }

    getCustomValues() {
        return R.pipe(
            R.filter(val => !this.state.defaultMap[val.toLowerCase()]),
            R.map(val => val.toLowerCase())
        )(this.state.value);
    }

    getValue() {
        const {value} = this.state;
        return value.length ? value.join(',') : null;
    }

    getValidationOptions() {
        return {
            path: this.props.ctx.path,
            context: t.mixin(t.mixin({}, this.props.context || this.props.ctx.context), {
                options: this.props.options
            })
        };
    }

    validate() {
        const value = this.getValue();
        const result = t.validate(value, this.props.type, this.getValidationOptions());
        this.setState({hasError: !result.isValid()});
        return result;
    }

    handleDefaultOptionsChange = defaultValues => {
        const customs = this.getCustomValues();
        const unionValues = R.union(customs, defaultValues);
        this.setState({value: unionValues}, () => {
            this.props.onChange(this.getValue(), this.props.ctx.path);
        });
    };

    handleCustomOptionsChange = customValues => {
        const defaults = this.getDefaultValues();
        const unionValues = R.union(defaults, customValues ? customValues.split(',') : []);
        this.setState({value: unionValues}, () => {
            this.props.onChange(this.getValue(), this.props.ctx.path);
        });
    };

    render() {
        const {value, hasError} = this.state;
        let placeholder = this.props.options && this.props.options.placeholder;
        if (value && value.length) {
            placeholder = null;
        }

        const label = this.props.options.label || this.props.ctx.label;
        const subTitle = this.props.options.subTitle || null;
        const customValues = this.getCustomValues();

        return (
            <div
                className={classNames(
                    'form-group',
                    hasError && 'has-error',
                    this.props.options.name
                )}
            >
                <label className="control-label">
                    {label}
                    {hasError ? 'Please select at least one interest' : null}
                </label>
                <FormMultiRadio
                    value={this.getDefaultValues()}
                    ctx={{name: 'default-values'}}
                    onChange={this.handleDefaultOptionsChange}
                    options={{
                        label: subTitle,
                        noSort: true,
                        noMaxSelectable: true,
                        customBtnClass: 'tag-input-default-value',
                        optionsMap: R.reduce(
                            (acc, val) => {
                                acc[val.toLowerCase()] = val;
                                return acc;
                            },
                            {},
                            this.props.options.defaultValues
                        )
                    }}
                />
                <FormToggleComponent
                    label={`+ Add ${this.props.options.customSectionLabel}`}
                    isVisible={customValues.length > 0}
                >
                    <label>{this.props.options.customSectionLabel}</label>
                    <FormTagInput
                        value={customValues.join(',')}
                        ctx={{name: 'custom-values'}}
                        onChange={this.handleCustomOptionsChange}
                        options={{
                            placeholder
                        }}
                    />
                </FormToggleComponent>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./form_components/form_tag_input_with_radio_defaults.js